import CustomTag from "components/Atoms/CustomTag"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import { VarietyGroupBenchmarkDataQuery } from "generated/graphql"
import React from "react"
import { inr } from "utils/formatters.utils"
dayjs.extend(advancedFormat)

interface VarietyBenchmarksProps {
  benchmarks?: VarietyGroupBenchmarkDataQuery["allPriceBenchmarkRecommendations"]
}
const VarietyBenchmarks = ({ benchmarks }: VarietyBenchmarksProps) => {
  return (
    <div className="sk-variety-benchmarks">
      {benchmarks?.map(b => {
        const price = b?.recommendedPrice
        return (
          <div key={b?.id}>
            <div>
              <CustomTag round minimal className="mr-3">
                {dayjs(b?.date).format("Do MMMM")}
              </CustomTag>
            </div>
            <div>
              <span className="vt-muted">{b?.grade?.name} @ </span>
              {inr(price?.price)} / {price?.priceUnit.name}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default VarietyBenchmarks
